import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M4 8.667H1.333a.667.667 0 0 0-.666.666v5.334a.667.667 0 0 0 .666.666H4a.666.666 0 0 0 .667-.666V9.333A.667.667 0 0 0 4 8.667M3.333 14H2v-4h1.333zm11.334-8H12a.666.666 0 0 0-.667.667v8a.666.666 0 0 0 .667.666h2.667a.666.666 0 0 0 .666-.666v-8A.666.666 0 0 0 14.667 6M14 14h-1.333V7.333H14zM9.333.667H6.667A.667.667 0 0 0 6 1.333v13.334a.667.667 0 0 0 .667.666h2.666a.666.666 0 0 0 .667-.666V1.333a.667.667 0 0 0-.667-.666M8.667 14H7.333V2h1.334z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })